import client from './client';

export const login = async (email, password) => {
  const response = await client.post('/auth/login', { email, password });
  const { token, user } = response.data;
  localStorage.setItem('token', token);
  localStorage.setItem('user', JSON.stringify(user));
  return { token, user };
};

export const logout = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
};

export const getCurrentUser = async () => {
  const response = await client.get('/auth/me');
  return response.data.user;
};

export const register = async (email, password, name, role) => {
  const response = await client.post('/auth/register', { email, password, name, role });
  return response.data.user;
};
